// extracted by mini-css-extract-plugin
module.exports = {"block":"HeaderBlock_block__32rXK","title":"HeaderBlock_title__31n1X","body":"HeaderBlock_body__ziet7"};